import {tns} from '../../node_modules/tiny-slider/src/tiny-slider.js';

/** DOMTokenList */
// https://github.com/Alhadis/Fix-IE/edit/master/src/token-list.js
!function(){"use strict";var n,r,t,e,i=window,o=document,u=Object,f=null,a=!0,c=!1,l=" ",s="Element",d="create"+s,h="DOMTokenList",m="__defineGetter__",p="defineProperty",v="class",g="List",y=v+g,w="rel",L=w+g,_="div",b="length",j="contains",S="apply",k="HTML",E=("item "+j+" add remove toggle toString toLocaleString").split(l),A=E[2],C=E[3],M=E[4],N="prototype",O=p in u||m in u[N]||f,T=function(n,r,t,e){u[p]?u[p](n,r,{configurable:c===O?a:!!e,get:t}):n[m](r,t)},x=function(r,t){var e=this,i=[],o={},f=0,s=0,d=function(){if(f>=s)for(;f>s;++s)(function(n){T(e,n,function(){return h(),i[n]},c)})(s)},h=function(){var n,e,u=arguments,c=/\s+/;if(u[b])for(e=0;e<u[b];++e)if(c.test(u[e]))throw n=new SyntaxError('String "'+u[e]+'" '+j+" an invalid character"),n.code=5,n.name="InvalidCharacterError",n;for(i=(""+r[t]).replace(/^\s+|\s+$/g,"").split(c),""===i[0]&&(i=[]),o={},e=0;e<i[b];++e)o[i[e]]=a;f=i[b],d()};return h(),T(e,b,function(){return h(),f}),e[E[6]]=e[E[5]]=function(){return h(),i.join(l)},e.item=function(n){return h(),i[n]},e[j]=function(n){return h(),!!o[n]},e[A]=function(){h[S](e,n=arguments);for(var n,u,c=0,s=n[b];s>c;++c)u=n[c],o[u]||(i.push(u),o[u]=a);f!==i[b]&&(f=i[b]>>>0,r[t]=i.join(l),d())},e[C]=function(){h[S](e,n=arguments);for(var n,u={},c=0,s=[];c<n[b];++c)u[n[c]]=a,delete o[n[c]];for(c=0;c<i[b];++c)u[i[c]]||s.push(i[c]);i=s,f=s[b]>>>0,r[t]=i.join(l),d()},e[M]=function(r,t){return h[S](e,[r]),n!==t?t?(e[A](r),a):(e[C](r),c):o[r]?(e[C](r),c):(e[A](r),a)},function(n,r){if(r)for(var t=0;7>t;++t)r(n,E[t],{enumerable:c})}(e,u[p]),e},D=function(n,r,t){T(n[N],r,function(){var n,e=this,i=m+p+r;if(e[i])return n;if(e[i]=a,c===O){for(var u,f=D.mirror=D.mirror||o[d](_),l=f.childNodes,s=l[b],h=0;s>h;++h)if(l[h]._R===e){u=l[h];break}u||(u=f.appendChild(o[d](_))),n=x.call(u,e,t)}else n=new x(e,t);return T(e,r,function(){return n}),delete e[i],n},a)};if(i[h])r=o[d](_)[y],N=i[h][N],r[A][S](r,E),2>r[b]&&(t=N[A],e=N[C],N[A]=function(){for(var n=0,r=arguments;n<r[b];++n)t.call(this,r[n])},N[C]=function(){for(var n=0,r=arguments;n<r[b];++n)e.call(this,r[n])}),r[M](g,c)&&(N[M]=function(r,t){var e=this;return e[(t=n===t?!e[j](r):t)?A:C](r),!!t});else{if(O)try{T({},"support")}catch(G){O=c}x.polyfill=a,i[h]=x,D(i[s],y,v+"Name"),D(i[k+"Link"+s],L,w),D(i[k+"Anchor"+s],L,w),D(i[k+"Area"+s],L,w)}}();

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-datalistelem !*/
// !function(e,n,t){function o(e,n){return typeof e===n}function s(){var e,n,t,s,a,l,u;for(var f in i)if(i.hasOwnProperty(f)){if(e=[],n=i[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)l=e[a],u=l.split("."),1===u.length?Modernizr[u[0]]=s:(!Modernizr[u[0]]||Modernizr[u[0]]instanceof Boolean||(Modernizr[u[0]]=new Boolean(Modernizr[u[0]])),Modernizr[u[0]][u[1]]=s),r.push((s?"":"no-")+u.join("-"))}}function a(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):f?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}var i=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){i.push({name:e,fn:n,options:t})},addAsyncTest:function(e){i.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var r=[],u=n.documentElement,f="svg"===u.nodeName.toLowerCase(),p=a("input"),c="autocomplete autofocus list placeholder max min multiple pattern required step".split(" "),d={};Modernizr.input=function(n){for(var t=0,o=n.length;o>t;t++)d[n[t]]=!!(n[t]in p);return d.list&&(d.list=!(!a("datalist")||!e.HTMLDataListElement)),d}(c),Modernizr.addTest("datalistelem",Modernizr.input.list),s(),delete l.addTest,delete l.addAsyncTest;for(var m=0;m<Modernizr._q.length;m++)Modernizr._q[m]();e.Modernizr=Modernizr}(window,document);

// https://github.com/iamdustan/smoothscroll/blob/master/src/smoothscroll.js
// !function(){"use strict";function o(){var o=window,t=document;if(!("scrollBehavior"in t.documentElement.style&&!0!==o.__forceSmoothScrollPolyfill__)){var l,e=o.HTMLElement||o.Element,r=468,i={scroll:o.scroll||o.scrollTo,scrollBy:o.scrollBy,elementScroll:e.prototype.scroll||n,scrollIntoView:e.prototype.scrollIntoView},s=o.performance&&o.performance.now?o.performance.now.bind(o.performance):Date.now,c=(l=o.navigator.userAgent,new RegExp(["MSIE ","Trident/","Edge/"].join("|")).test(l)?1:0);o.scroll=o.scrollTo=function(){void 0!==arguments[0]&&(!0!==f(arguments[0])?h.call(o,t.body,void 0!==arguments[0].left?~~arguments[0].left:o.scrollX||o.pageXOffset,void 0!==arguments[0].top?~~arguments[0].top:o.scrollY||o.pageYOffset):i.scroll.call(o,void 0!==arguments[0].left?arguments[0].left:"object"!=typeof arguments[0]?arguments[0]:o.scrollX||o.pageXOffset,void 0!==arguments[0].top?arguments[0].top:void 0!==arguments[1]?arguments[1]:o.scrollY||o.pageYOffset))},o.scrollBy=function(){void 0!==arguments[0]&&(f(arguments[0])?i.scrollBy.call(o,void 0!==arguments[0].left?arguments[0].left:"object"!=typeof arguments[0]?arguments[0]:0,void 0!==arguments[0].top?arguments[0].top:void 0!==arguments[1]?arguments[1]:0):h.call(o,t.body,~~arguments[0].left+(o.scrollX||o.pageXOffset),~~arguments[0].top+(o.scrollY||o.pageYOffset)))},e.prototype.scroll=e.prototype.scrollTo=function(){if(void 0!==arguments[0])if(!0!==f(arguments[0])){var o=arguments[0].left,t=arguments[0].top;h.call(this,this,void 0===o?this.scrollLeft:~~o,void 0===t?this.scrollTop:~~t)}else{if("number"==typeof arguments[0]&&void 0===arguments[1])throw new SyntaxError("Value could not be converted");i.elementScroll.call(this,void 0!==arguments[0].left?~~arguments[0].left:"object"!=typeof arguments[0]?~~arguments[0]:this.scrollLeft,void 0!==arguments[0].top?~~arguments[0].top:void 0!==arguments[1]?~~arguments[1]:this.scrollTop)}},e.prototype.scrollBy=function(){void 0!==arguments[0]&&(!0!==f(arguments[0])?this.scroll({left:~~arguments[0].left+this.scrollLeft,top:~~arguments[0].top+this.scrollTop,behavior:arguments[0].behavior}):i.elementScroll.call(this,void 0!==arguments[0].left?~~arguments[0].left+this.scrollLeft:~~arguments[0]+this.scrollLeft,void 0!==arguments[0].top?~~arguments[0].top+this.scrollTop:~~arguments[1]+this.scrollTop))},e.prototype.scrollIntoView=function(){if(!0!==f(arguments[0])){var l=function(o){for(;o!==t.body&&!1===(e=p(l=o,"Y")&&a(l,"Y"),r=p(l,"X")&&a(l,"X"),e||r);)o=o.parentNode||o.host;var l,e,r;return o}(this),e=l.getBoundingClientRect(),r=this.getBoundingClientRect();l!==t.body?(h.call(this,l,l.scrollLeft+r.left-e.left,l.scrollTop+r.top-e.top),"fixed"!==o.getComputedStyle(l).position&&o.scrollBy({left:e.left,top:e.top,behavior:"smooth"})):o.scrollBy({left:r.left,top:r.top,behavior:"smooth"})}else i.scrollIntoView.call(this,void 0===arguments[0]||arguments[0])}}function n(o,t){this.scrollLeft=o,this.scrollTop=t}function f(o){if(null===o||"object"!=typeof o||void 0===o.behavior||"auto"===o.behavior||"instant"===o.behavior)return!0;if("object"==typeof o&&"smooth"===o.behavior)return!1;throw new TypeError("behavior member of ScrollOptions "+o.behavior+" is not a valid value for enumeration ScrollBehavior.")}function p(o,t){return"Y"===t?o.clientHeight+c<o.scrollHeight:"X"===t?o.clientWidth+c<o.scrollWidth:void 0}function a(t,l){var e=o.getComputedStyle(t,null)["overflow"+l];return"auto"===e||"scroll"===e}function d(t){var l,e,i,c,n=(s()-t.startTime)/r;c=n=n>1?1:n,l=.5*(1-Math.cos(Math.PI*c)),e=t.startX+(t.x-t.startX)*l,i=t.startY+(t.y-t.startY)*l,t.method.call(t.scrollable,e,i),e===t.x&&i===t.y||o.requestAnimationFrame(d.bind(o,t))}function h(l,e,r){var c,f,p,a,h=s();l===t.body?(c=o,f=o.scrollX||o.pageXOffset,p=o.scrollY||o.pageYOffset,a=i.scroll):(c=l,f=l.scrollLeft,p=l.scrollTop,a=n),d({scrollable:c,method:a,startTime:h,startX:f,startY:p,x:e,y:r})}}"object"==typeof exports&&"undefined"!=typeof module?module.exports={polyfill:o}:o()}();
// if (!Modernizr.datalistelem) {
//   // https://github.com/Fyrd/purejs-datalist-polyfill
//   // license: MIT
//   (function(document) {
//       var IE_SELECT_ATTRIBUTE = 'data-datalist';
//       var LIST_CLASS = 'datalist-polyfill';
//       var ACTIVE_CLASS = 'datalist-polyfill__active';

//       var datalistSupported = !!(document.createElement('datalist') && window.HTMLDataListElement);
//       var ua = navigator.userAgent;

//       // Android does not have actual support
//       var isAndroidBrowser = ua.match(/Android/) && !ua.match(/(Firefox|Chrome|Opera|OPR)/);
//       if( datalistSupported && !isAndroidBrowser ) {
//           return;
//       }

//       var inputs = document.querySelectorAll('input[list]');

//       var triggerEvent = function(elem, eventType) {
//           var event;
//           if (document.createEvent) {
//               event = document.createEvent("HTMLEvents");
//               event.initEvent(eventType, true, true);
//               elem.dispatchEvent(event);
//           } else {
//               event = document.createEventObject();
//               event.eventType = eventType;
//               elem.fireEvent("on" + eventType, event);
//           }
//       };

//       for( var i = 0; i < inputs.length; i++ ) {
//           var input = inputs[i];
//           var listId = input.getAttribute('list');
//           var datalist = document.getElementById(listId);
//           if( !datalist ) {
//               console.error('No datalist found for input: ' + listId);
//               return;
//           }

//           // Only visible to <= IE9
//           var childSelect = document.querySelector('select[' + IE_SELECT_ATTRIBUTE + '="' + listId + '"]');
//           var parent = childSelect || datalist;
//           var listItems = parent.getElementsByTagName('option');
//           convert(input, datalist, listItems);
//           if( childSelect ) {
//               childSelect.parentNode.removeChild( childSelect );
//           }
//       }

//       function convert(input, datalist, listItems) {
//           var fakeList = document.createElement('ul');
//           var visibleItems = null;
//           fakeList.id = listId;
//           fakeList.className = LIST_CLASS;
//           input.parentNode.appendChild( fakeList );

//           var scrollValue = 0;

//             // Used to prevent reflow
//           var tempItems = document.createDocumentFragment();

//           for( var i = 0; i < listItems.length; i++ ) {
//               var item = listItems[i];
//               var li = document.createElement('li');
//               li.innerText = item.value;
//               tempItems.appendChild( li );
//           }
//           fakeList.appendChild( tempItems );
//           var fakeItems = fakeList.childNodes;
//           var eachItem = function(callback) {
//               for( var i = 0; i < fakeItems.length; i++ ) {
//                   callback(fakeItems[i]);
//               }
//           };
//           var listen = function(elem, event, func) {
//               if( elem.addEventListener ) {
//                   elem.addEventListener(event, func, false);
//               } else {
//                   elem.attachEvent('on' + event, func);
//               }
//           };

//           datalist.parentNode.removeChild( datalist );

//           listen(input, 'focus', function() {
//               // Reset scroll
//               fakeList.scrollTop = 0;
//               scrollValue = 0;
//           });

//           listen(input, 'blur', function(evt) {
//               // If this fires immediately, it prevents click-to-select from working
//               setTimeout(function() {
//                   fakeList.style.display = 'none';
//                   eachItem( function(item) {
//                       // Note: removes all, not just ACTIVE_CLASS, but should be safe
//                       item.className = '';
//                   });
//               }, 100);
//           });

//           var positionList = function() {
//               fakeList.style.top = input.offsetTop + input.offsetHeight + 'px';
//               fakeList.style.left = input.offsetLeft + 'px';
//               fakeList.style.width = input.offsetWidth + 'px';
//           };

//           var itemSelected = function(item) {
//               input.value = item.innerText;
//               triggerEvent(input, 'change');
//               setTimeout(function() {
//                   fakeList.style.display = 'none';
//               }, 100);
//           };

//           var buildList = function(e) {
//               // Build datalist
//               fakeList.style.display = 'block';
//               positionList();
//               visibleItems = [];
//               eachItem( function(item) {
//                   // Note: removes all, not just ACTIVE_CLASS, but should be safe
//                   var query = input.value.toLowerCase();
//                   var isFound = query.length && item.innerText.toLowerCase().indexOf( query ) > -1;
//                   if( isFound ) {
//                       visibleItems.push( item );
//                   }
//                   item.style.display = isFound ? 'block' : 'none';
//               } );
//           };

//           listen(input, 'keyup', buildList);
//           listen(input, 'focus', buildList);

//           // Don't want to use :hover in CSS so doing this instead
//           // really helps with arrow key navigation
//           eachItem( function(item) {
//               // Note: removes all, not just ACTIVE_CLASS, but should be safe
//               listen(item, 'mouseover', function(evt) {
//                   eachItem( function(_item) {
//                       _item.className = item == _item ? ACTIVE_CLASS : '';
//                   });
//               });
//               listen(item, 'mouseout', function(evt) {
//                   item.className = '';
//               });
//               // Mousedown fires before native 'change' event is triggered
//               // So we use this instead of click so only the new value is passed to 'change'
//               listen(item, 'mousedown', function(evt) {
//                   itemSelected(item);
//               });
//           });

//           listen(window, 'resize', positionList);

//           listen(input, 'keydown', function(e) {
//               var activeItem = fakeList.querySelector("." + ACTIVE_CLASS);
//               if( !visibleItems.length ) {
//                   return;
//               }

//               var lastVisible = visibleItems[ visibleItems.length-1 ];
//               var datalistItemsHeight = lastVisible.offsetTop + lastVisible.offsetHeight;

//               // up/down arrows
//               var isUp = e.keyCode == 38;
//               var isDown = e.keyCode == 40;
//               if ( (isUp || isDown) ) {
//                   if( isDown && !activeItem ) {
//                       visibleItems[0].className = ACTIVE_CLASS;
//                   } else if (activeItem) {
//                       var prevVisible = null;
//                       var nextVisible = null;
//                       for( var i = 0; i < visibleItems.length; i++ ) {
//                           var visItem = visibleItems[i];
//                           if( visItem == activeItem ) {
//                               prevVisible = visibleItems[i-1];
//                               nextVisible = visibleItems[i+1];
//                               break;
//                           }
//                       }

//                       activeItem.className = '';
//                       if ( isUp ) {
//                           if( prevVisible ) {
//                               prevVisible.className = ACTIVE_CLASS;
//                               if ( prevVisible.offsetTop < fakeList.scrollTop ) {
//                                   fakeList.scrollTop -= prevVisible.offsetHeight;
//                               }
//                           } else {
//                               visibleItems[visibleItems.length - 1].className = ACTIVE_CLASS;
//                           }
//                       }
//                       if ( isDown ) {
//                           if( nextVisible ) {
//                               nextVisible.className = ACTIVE_CLASS;
//                               if( nextVisible.offsetTop + nextVisible.offsetHeight > fakeList.scrollTop + fakeList.offsetHeight ) {
//                                   fakeList.scrollTop += nextVisible.offsetHeight;
//                               }
//                           } else {
//                               visibleItems[0].className = ACTIVE_CLASS;
//                           }
//                       }
//                   }
//               }

//               // return or tab key
//               if ( activeItem && (e.keyCode == 13 || e.keyCode == 9) ){
//                   itemSelected(activeItem);
//               }
//           });
//       }
//   }(document));
// }



let doc = document,
    win = window,
    body = doc.body,
    raf = win.requestAnimationFrame
      || win.webkitRequestAnimationFrame
      || win.mozRequestAnimationFrame
      || win.msRequestAnimationFrame
      || function(cb) { return setTimeout(cb, 16); },
    initializeClass = 'initialized',
    sliderInit = function(el) {
      el.classList.remove('slider-fallback');
      el.classList.add(initializeClass);
    };

function forEach (arr, callback, scope) {
  for (var i = 0, l = arr.length; i < l; i++) {
    callback.call(scope, arr[i], i);
  }
}

function lookupByClass (el, cla) {
  if (el === body) { return null; }
  return !el.classList.contains(cla) ? lookupByClass(el.parentNode, cla) : el;
}

function getOffsetTop (el) {
  return el.getBoundingClientRect().top + document.documentElement.scrollTop;
}





// skip link
let skip_link = doc.querySelector('.skip-link');
skip_link && skip_link.addEventListener('click', function(e) {
  e.preventDefault();
  doc.querySelector(e.target.getAttribute('href')).focus();
});





// sticky header
let lastScrollPosition = 0,
    resizeTicking = false,
    scrollTicking = false,
    // scrollingClass = 'has-sticky-header',
    fixed_header = doc.querySelector('.fixed-header'),
    header = doc.querySelector('.site-header'),
    headerHeight = 0;
if (header) {
  // let body_classlist = body.classList,
      // isHolidayPage = body_classlist.contains('holiday-guide-2018-page'),
      // noStickyHeader = body_classlist.contains('p404-page') || body_classlist.contains('brand-voice-page');
  headerHeight = header.offsetHeight;

  if (fixed_header) {
    // fixed_header.classList.add('fixed-header');
    // body.style.paddingTop = headerHeight + 'px';

    win.addEventListener('resize', function(e) {
      if (!resizeTicking) {
        raf(function() {
          let height = header.offsetHeight;
          if (height !== headerHeight) {
            // body.style.paddingTop = height + 'px';
            headerHeight = height;

            // if (!isHolidayPage) { stickHeader(lastScrollPosition); }
          }

          resizeTicking = false;
        });
        resizeTicking = true;
      }
    });

    // if (isHolidayPage) {
    //   body.classList.add(scrollingClass);
    // } else {
      win.addEventListener('scroll', function(e) {
        let pos = lastScrollPosition;
        lastScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

        if (!scrollTicking) {
          raf(function() {
            stickHeader(lastScrollPosition, pos - lastScrollPosition);
            scrollTicking = false;
          });
          scrollTicking = true;
        }
      });
    // }
  }
}

function stickHeader(position, scroll_down) {
  if (position > (headerHeight + 20)) {
    // if (!body.classList.contains(scrollingClass)) { body.classList.add(scrollingClass); }

    // update when scrolling minimum 5px
    if (Math.abs(scroll_down) > 5) {
      if (scroll_down > 0) {
        if (!fixed_header.classList.contains('goes-down')) {
          fixed_header.classList.add('goes-down');
        }

      } else {
        if (fixed_header.classList.contains('goes-down')) {
          fixed_header.classList.remove('goes-down');
        }
      }
    }

  } else {
    // if (body.classList.contains(scrollingClass)) { body.classList.remove(scrollingClass); }
    if (fixed_header.classList.contains('goes-down')) { fixed_header.classList.remove('goes-down'); }
  }
}

let iframe_attr = 'data-iframe-show',
    iframe_toggles = doc.querySelectorAll('[' + iframe_attr + ']');
if (iframe_toggles.length) {
  forEach(iframe_toggles, (el) => {
    el.addEventListener('click', (e) => {
      let iframe = doc.querySelector('.iframe-popup'),
          file = el.getAttribute(iframe_attr);

      if (file) {
        e.preventDefault();
        if (!iframe) {
          iframe = doc.createElement('iframe');
          iframe.className = 'iframe-popup';
          body.appendChild(iframe);
        }
        if (iframe.getAttribute(iframe_attr) !== file) { iframe.setAttribute('src', file); }
      }
    });
  });
}



function addRelatedToggle (root) {
  if (root == null) { root = doc; }
  let toggle_class = 'toggle-added',
      related_story_el = root.querySelector('.related-stories:not(.' + toggle_class + ')');
  if (related_story_el) {
    related_story_el.classList.add(toggle_class);
    related_story_el.insertAdjacentHTML('beforeend', '<button class="related-stories-toggle" data-js-toggle="#main" data-class="hide-related"><span class="i-angle"><span class="i-container"><svg width="18" height="18" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M13 2l22 22-22 22" stroke="currentColor" fill="none"/></svg></span></span></button>');
  }
}
addRelatedToggle();

// function get_inlineform_code (type, txt) {
//   let placeholder = '',
//       cancel_txt = 'cancel',
//       submit_txt = 'update',
//       content = txt ? txt : '',
//       attr1 = '',
//       attr2 = '';

//   if (type === 'reply') {
//     placeholder = 'placeholder="Add a reply …"';
//     cancel_txt = '<span class="i-close"><span></span></span> close';
//     submit_txt = 'post';
//   } else {
//     let common = ' data-comment-' + type + '="';
//     attr1 = common + cancel_txt + '"';
//     attr2 = common + submit_txt + '"';
//   }

//   return '<div class="comments-row comments-' + type + '"> <form action="/comments"> <textarea name="comments" cols="90" rows="8" ' + placeholder + '>' + content + '</textarea> <div class="comments-btnline"> <button class="comments-' + type + '-close" aria-label="Cancel ' + type + '"' + attr1 + '>' + cancel_txt + '</button> <button' + attr2 + '>' + submit_txt + '</button> </div> </form> </div>';
// }

// function doCommentActions (root) {
//   if (root == null) { root = doc; }
//   let comments_bodys = root.querySelectorAll('.comments-body:not(.initialized)'),
//       cl = 'active',
//       len = comments_bodys.length;
//   if (len) {
//     forEach(comments_bodys, function(item) {
//       item.classList.add('initialized');
//       item.addEventListener('click', function(e) {
//         let tar = e.target;
//         if (tar) {
//           if (tar.classList.contains('comment-share')) {
//             tar.nextElementSibling.classList.toggle('open');

//           // add reply box
//           } else if (tar.classList.contains('comment-reply')) {
//             let action_line = tar.parentNode,
//                 thread = action_line.parentNode,
//                 next_el = action_line.nextElementSibling;
//             if (!next_el || !next_el.classList.contains('comments-reply')) {
//               action_line.insertAdjacentHTML('afterend', get_inlineform_code('reply'));
//             }

//           // edit comment
//           } else if (tar.classList.contains('comment-edit')) {
//             e.preventDefault();
//             let content = lookupByClass(tar, 'comments-content');
//             if (content && !content.querySelector('.comments-edit')) {
//               let message = content.querySelector('.comment-message'),
//                   p = message.querySelectorAll('p'),
//                   txt = '';

//               for (var i = 0; i < p.length; i++) {
//                 txt += p[i].textContent + '\n';
//               }

//               message.insertAdjacentHTML('beforebegin', get_inlineform_code('edit', txt));
//             }

//           // update comment
//           } else if (tar.hasAttribute('data-comment-edit')) {
//             e.preventDefault();

//             let box = lookupByClass(tar, 'comments-edit');

//             if (tar.getAttribute('data-comment-edit') === 'update') {
//               let message, arr, html = '';
//               try {
//                 message = box.querySelector('textarea').value;
//                 arr = message.split('\n');

//                 arr.forEach(function(p) {
//                   if (p) { html += ' <p>' + p + '</p>'}
//                 });

//                 if (html) {
//                   box.nextElementSibling.innerHTML = html;
//                 }
//               } catch(e) {
//               }
//             }

//             box.parentNode.removeChild(box);

//           // delete comment
//           } else if (tar.classList.contains('comment-delete')) {
//             e.preventDefault();

//             let src = tar.getAttribute('href'),
//                 iframe = doc.querySelector('[src$="' + src + '"]');

//             if (iframe) {
//               iframe.style.display = '';
//             } else {
//               iframe = doc.createElement('iframe');
//               iframe.className = tar.getAttribute(popup_link_attr);
//               iframe.src = src;
//               body.appendChild(iframe);
//             }

//             // if ('ontouchstart' in window || 'onmsgesturechange' in window) {
//             //   body.classList.add('no-scroll');
//             // }

//           } else {
//             let vote_el = lookupByClass(tar, 'comment-up') || lookupByClass(tar, 'comment-down'),
//                 close_reply = lookupByClass(tar, 'comments-reply-close');
//             if (vote_el) {
//               let vote_el_sibling = vote_el.parentNode.querySelector(vote_el.classList.contains('comment-up') ? '.comment-down' : '.comment-up');

//               vote_el.classList.toggle(cl);
//               if (vote_el_sibling && vote_el_sibling.classList.contains(cl)) { vote_el_sibling.classList.remove(cl); }

//             // close reply box
//             } else if (close_reply) {
//               let reply = lookupByClass(close_reply, 'comments-reply');
//               if (reply) { reply.parentNode.removeChild(reply); }
//             }
//           }
//         }
//       });
//     });
//   }
// }
// doCommentActions();

// function get_inlineform_code_new (type, txt) {
//   let placeholder = '',
//       cancel_txt = 'cancel',
//       submit_txt = 'update',
//       content = txt ? txt : '',
//       attr1 = '',
//       attr2 = '';

//   if (type === 'reply') {
//     placeholder = 'placeholder="Add a reply …"';
//     cancel_txt = '<span class="i-close"><span></span></span> close';
//     submit_txt = 'post';
//   } else {
//     let common = ' data-cment-' + type + '="';
//     attr1 = common + cancel_txt + '"';
//     attr2 = common + submit_txt + '"';
//   }

//   return '<div class="cment-row cment-' + type + '-box"> <form action="/cment"> <textarea name="cment" cols="90" rows="8" ' + placeholder + '>' + content + '</textarea> <div class="cment-btnline"> <button class="cment-' + type + '-close" aria-label="Cancel ' + type + '"' + attr1 + '>' + cancel_txt + '</button> <button' + attr2 + '>' + submit_txt + '</button> </div> </form> </div>';
// }

// function doCmentActions (root) {
//   if (root == null) { root = doc; }
//   let cment_bodys = root.querySelectorAll('.cment-body:not(.initialized)'),
//       cl = 'active',
//       len = cment_bodys.length;
//   if (len) {
//     forEach(cment_bodys, function(item) {
//       item.classList.add('initialized');
//       item.addEventListener('click', function(e) {
//         let tar = e.target;
//         if (tar && !tar.classList.contains('cment-delete')) {
//           if (tar.classList.contains('cment-share')) {
//             tar.nextElementSibling.classList.toggle('open');

//           // add reply box
//           } else if (tar.classList.contains('cment-reply')) {
//             let action_line = tar.parentNode,
//                 thread = action_line.parentNode,
//                 next_el = action_line.nextElementSibling;
//             if (!next_el || !next_el.classList.contains('cment-reply')) {
//               action_line.insertAdjacentHTML('afterend', get_inlineform_code_new('reply'));
//             }

//           // edit cment
//           } else if (tar.classList.contains('cment-edit')) {
//             e.preventDefault();
//             let content = lookupByClass(tar, 'cment-content');
//             if (content && !content.querySelector('.cment-edit-box')) {
//               let message = content.querySelector('.cment-message'),
//                   p = message.querySelectorAll('p'),
//                   txt = '';

//               for (var i = 0; i < p.length; i++) {
//                 txt += p[i].textContent + '\n';
//               }

//               message.insertAdjacentHTML('beforebegin', get_inlineform_code_new('edit', txt));
//             }

//           // update cment
//           } else if (tar.hasAttribute('data-cment-edit')) {
//             e.preventDefault();

//             let box = lookupByClass(tar, 'cment-edit-box');

//             if (tar.getAttribute('data-cment-edit') === 'update') {
//               let message, arr, html = '';
//               try {
//                 message = box.querySelector('textarea').value;
//                 arr = message.split('\n');

//                 arr.forEach(function(p) {
//                   if (p) { html += ' <p>' + p + '</p>'}
//                 });

//                 if (html) {
//                   box.nextElementSibling.innerHTML = html;
//                 }
//               } catch(e) {
//               }
//             }

//             box.parentNode.removeChild(box);

//           // delete cment
//           // } else if (tar.classList.contains('cment-delete')) {
//           //   e.preventDefault();

//           //   let src = tar.getAttribute('href'),
//           //       iframe = doc.querySelector('[src$="' + src + '"]');

//           //   if (iframe) {
//           //     iframe.style.display = '';
//           //   } else {
//           //     iframe = doc.createElement('iframe');
//           //     iframe.className = tar.getAttribute(popup_link_attr);
//           //     iframe.src = src;
//           //     body.appendChild(iframe);
//           //   }

//           //   if ('ontouchstart' in window || 'onmsgesturechange' in window) {
//           //     body.classList.add('no-scroll');
//           //   }

//           } else {
//             let vote_el = lookupByClass(tar, 'cment-up'),
//                 close_reply = lookupByClass(tar, 'cment-reply-close');
//             if (vote_el) {
//               // let vote_el_sibling = vote_el.parentNode.querySelector(vote_el.classList.contains('cment-up') ? '.cment-down' : '.cment-up');

//               vote_el.classList.toggle(cl);
//               // if (vote_el_sibling && vote_el_sibling.classList.contains(cl)) { vote_el_sibling.classList.remove(cl); }

//             // close reply box
//             } else if (close_reply) {
//               let reply = lookupByClass(close_reply, 'cment-reply-box');
//               if (reply) { reply.parentNode.removeChild(reply); }
//             }
//           }
//         }
//       });
//     });
//   }
// }
// doCmentActions();

function doPrint (root) {
  if (root == null) { root = doc; }
  let btn_print_with_img = root.querySelector('.js-print-img'),
      btn_print_without_img = root.querySelector('.js-print-no-img'),
      cl = 'print-without-img';
  if (btn_print_with_img) {
    btn_print_with_img.addEventListener('click', (e) => {
      body.classList.remove(cl);
      (function action () {
        setTimeout(function() {
          if (!body.classList.contains(cl)) {
            win.print();
          } else {
            action();
          }
        }, 10);
      })();
    });
  }
  if (btn_print_without_img) {
    btn_print_without_img.addEventListener('click', (e) => {
      body.classList.add(cl);
      // setTimeout(function() { win.print(); }, 300);
      (function action () {
        setTimeout(function() {
          if (body.classList.contains(cl)) {
            win.print();
          } else {
            action();
          }
        }, 10);
      })();
    });
  }
}
doPrint();

// toggle buttons
function addToggleEvents (root) {
  if (root == null) { root = doc; }
  let toggleAttr = "data-js-toggle",
      openClass = 'open',
      expandClass = 'expand',
      btns = root.querySelectorAll('[' + toggleAttr + ']:not(.' + initializeClass + ')');

  forEach(btns, (btn) => {
      let selector = btn.getAttribute(toggleAttr),
          rt = btn.classList.contains('menu') ? lookupByClass(btn, 'share-icons') : root,
          el = rt.querySelector(selector);

      if (el) {
        let cl = btn.getAttribute('data-class');

        btn.addEventListener('click', function(e) {
          e.preventDefault();

          if (selector === '.cment-box') {
            let ovh_cl = 'ovh';
            if (el.classList.contains(openClass) &&
                body.classList.contains(ovh_cl)) {
              body.classList.remove(ovh_cl);
            } else if (!el.classList.contains(openClass) &&
                !body.classList.contains(ovh_cl)) {
              body.classList.add(ovh_cl);
            }
          }

          btn.classList.toggle(expandClass);
          el.classList.toggle(cl || openClass);
          // set hide-related-articles variable
          if (cl === 'hide-related') {
            try {
              win.sessionStorage.setItem(cl, el.classList.contains(cl) ? 'yes' : 'no');
            } catch(e) {
              win[cl] = el.classList.contains(cl) ? 'yes' : 'no';
            }
          }

          // if (selector.indexOf('offcanvas') >= 0) {
          //   let cl_offcanvas = 'offcanvas-opened',
          //       cl_noscroll = 'no-scroll';
          //   fixed_header.classList.toggle(cl_offcanvas);

          //   if ('ontouchstart' in win || 'onmsgesturechange' in win) {
          //     if (el.classList.contains(openClass)) {
          //       body.classList.add(cl_noscroll);
          //     } else {
          //       body.classList.remove(cl_noscroll);
          //     }
          //   }
          // }

          // set focus on search input
          if (el.classList.contains(cl || openClass) && el.classList.contains('search-form')) {
            el.querySelector('input').focus();
          }
        });

        btn.classList.add(initializeClass);
      }
  });
};
addToggleEvents(doc);

// subnav
let subnavs = doc.querySelectorAll('.subnav');
if (subnavs.length) {
  forEach(subnavs, (el) => {
    if (el.querySelectorAll('.has-dropdown').length) {
      el.addEventListener('click', (e) => {
        let btn = lookupByClass(e.target, 'dd-toggle');
        if (btn) {
          let dd = btn.parentNode.querySelector('.dropdown');
          if (dd) {
            let cl_open = 'open',
                cl_active = 'active';
            if (dd.classList.contains(cl_open)) {
              btn.classList.remove(cl_active);
            } else {
              btn.classList.add(cl_active);
            }

            dd.classList.toggle(cl_open);
          }
        }
      });
    }
  });
}

function checkRelatedBoxOption () {
  var cl = 'hide-related',
      hide,
      main = doc.querySelector('#main');

  if (main) {
    try {
      if (win.sessionStorage.getItem(cl) === 'yes') { hide = true; }
    } catch(e) {
      if (win[cl] === 'yes') { hide = true; }
    }

    if (hide) {
      main.classList.add(cl);
    }
  }
}
checkRelatedBoxOption();

// win.addEventListener('click', exitAll);
// win.addEventListener('keydown', (e) => {
//   if (event.defaultPrevented) { return; } // Do nothing if the event was already processed
//   if ((e.key && e.key === "Escape") || (e.keycode && e.keycode === 27)) { exitAll(e); }
// });

// function exitAll (e) {
//   let openBoxes = doc.querySelectorAll('.' + openClass),
//       openBoxesLen = openBoxes.length,
//       target = e.target;

//   // return if the target is a toggle button
//   if (target.hasAttribute(toggleAttr)) { return; }

//   if (openBoxesLen) {
//     let parent = lookupByClass(target, openClass);

//     for(let l = openBoxesLen; l--;) {
//       let box = openBoxes[l];

//       if (box !== parent) {
//         let btn = doc.querySelector('[' + toggleAttr + '="#' + box.id + '"]');

//         if (btn) { btn.click(); }
//       }
//     }
//   }
// }




// close buttons
let closeAttr = "data-js-close",
    closeClass = 'visually-hidden',
    closeBtns = doc.querySelectorAll('[' + closeAttr + ']');
for(let l = closeBtns.length; l--;) {
  let el = closeBtns[l],
      target = doc.querySelector(el.getAttribute(closeAttr));
  if (el && target) {
    el.addEventListener('click', function(e) {
      if (!target.classList.contains(closeClass)) {
        e.preventDefault();
        target.classList.add(closeClass);
        // el.setAttribute('aria-expanded', 'false');
        // target.setAttribute('aria-hidden', 'true');
      }
    })
  }
}




// var scrollTo=function(){return function(t,e){function o(t,e,n){if(!(n<0)){var i,c=e-t.scrollTop,r=c/n*10,l=function(){t.scrollTop+=r,t.scrollTop!==e&&(o(t,e,n-10),i=!1)};i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(l):setTimeout(l,10))}}var n=document.body,i=document.documentElement,c=(i||n.parentNode||n).clientHeight,r=Math.max(n.scrollHeight,n.offsetHeight,i.clientHeight,i.scrollHeight,i.offsetHeight),l=t+c,u=r-c-1;l>r&&(t=u),t=Math.round(t),o(document.body,t,e),o(document.documentElement,t,e)}}();

// // data-scroll-to
// function scroll_to (root) {
//   if (root == null) { root = doc; }
//   let scrollToAttr = 'data-scroll-to',
//       scrollBtns = root.querySelectorAll('[' + scrollToAttr + ']');

//   if (scrollBtns.length) {
//     forEach(scrollBtns, (btn) => {
//       if (!btn.classList.contains(initializeClass)) {
//         btn.addEventListener('click', (e) => {
//           e.preventDefault();

//           let target = e.target;
//           while (!target.hasAttribute(scrollToAttr)) {
//             target = target.parentNode;
//           }

//           let main_layout = lookupByClass(target, 'main-layout');
//           if (main_layout) {
//             let location = main_layout.querySelector(target.getAttribute(scrollToAttr)).offsetTop - 100;
//             // scrollTo(location, 300);
//             window.scrollTo({top: location, left: 0, behavior: 'smooth'});
//           }
//         });

//         // add initialize class
//         btn.classList.add(initializeClass);
//       }
//     });
//   }
// }
// scroll_to();

// video page: scroll to top
// let videoRows = doc.querySelectorAll('.video-page .slider-row'),
//     videoRowsLen = videoRows.length;

// if (videoRowsLen) {
//   for(let l = videoRowsLen; l--;) {
//     let row = videoRows[l];
//     row.addEventListener('click', (e) => {
//       let target = e.target;

//       while (target.nodeName.toLowerCase() !== 'a' && !target.classList.contains('slider-row')) {
//         target = target.parentNode;
//       }

//       if (target.nodeName.toLowerCase() === 'a') {
//         e.preventDefault();
//         scrollTo(0, 300);
//       }
//     });
//   }
// }






// sticky social icons
var wh = win.innerHeight;
win.stories = [];
win.storiesTop = [];
win.storiesBottom = [];
win.social_rows = [];
win.related_story_boxes = [];
win.related_story_boxes_ref = [];

function getElements (root) {
  if (root == null) { root = doc; }
  let article = root.querySelector('.full-article'),
      share_icons = root.querySelector('.share-icons'),
      story = root.querySelector('.related-stories'),
      ref = root.querySelectorAll('.full-article > p, .full-article > ol > li, .full-article > ul > li')[3];

  stories.push(article ? article : false);
  social_rows.push(share_icons ? share_icons : false);
  related_story_boxes.push(story ? story : false);
  related_story_boxes_ref.push(ref ? ref : false);
}

function getStoriesTop () {
  let el = stories[stories.length - 1];
  if (el) { storiesTop.push(getOffsetTop(el)); }
}

function resetStoriesTop () {
  storiesTop = []; // reset story tops
  stories.forEach(function(el) {
    if (el) { storiesTop.push(getOffsetTop(el)); }
  });
}

win.addEventListener('load', function() {
  getElements();
  getStoriesTop();
});

if (body.classList.contains('article-page')) {
  let resizeTicking_social = false,
      scrollTicking_social = false,
      stuckClass = 'is-stuck';

  win.addEventListener('resize', function(e) {
    if (!resizeTicking_social) {
      raf(function() {
        wh = win.innerHeight;
        resetStoriesTop();

        resizeTicking_social = false;
      });
      resizeTicking_social = true;
    }
  });

  win.addEventListener('scroll', function(e) {
    var y = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

    if (!scrollTicking_social) {
      raf(function() {
        // update share-icon box status
        storiesTop.forEach(function(top, i) {
          let social_row = social_rows[i];

          if (y > top) {
            if (!social_row.classList.contains(stuckClass)) { social_row.classList.add(stuckClass); }
          } else {
            if (social_row.classList.contains(stuckClass)) { social_row.classList.remove(stuckClass); }
          }
        });

        // update related-stories box status
        related_story_boxes_ref.forEach(function(p, i) {
          let box = related_story_boxes[i];

          if (box) {
            let point,
                nextEl = box.nextElementSibling,
                box_bottom = nextEl ? nextEl.getBoundingClientRect().top : box.parentNode.getBoundingClientRect().bottom;

            // article has more than 6 paragraphes
            if (p && box_bottom >= wh) {
              point = wh - p.offsetHeight - 30;
              let p_top = p.getBoundingClientRect().top;

              if (p_top < point) {
                if (!box.classList.contains(stuckClass)) { box.classList.add(stuckClass); }
              } else {
                if (box.classList.contains(stuckClass)) { box.classList.remove(stuckClass); }
              }

            // show related-stories 600px away
            } else {
              // let els = stories[i].children,
              //     el = els[els.length - 1];
              let bottom = stories[i].getBoundingClientRect().bottom;
              point = wh + 600;

              if (box_bottom >= wh && bottom < point) {
                if (!box.classList.contains(stuckClass)) { box.classList.add(stuckClass); }
              } else {
                if (box.classList.contains(stuckClass)) { box.classList.remove(stuckClass); }
              }
            }
          }
        });

        scrollTicking_social = false;
      });
      scrollTicking_social = true;
    }
  });
}





function getControlsText (t) {
  return [
      '<span aria-label="Previous ' + t + '"><span class="i-angle"><span class="i-container"><svg width="18" height="18" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M35 2L13 24l22 22" stroke="currentColor" fill="none"/></svg></span></span></span>',
      '<span aria-label="Next ' + t + '"><span class="i-angle"><span class="i-container"><svg width="18" height="18" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M13 2l22 22-22 22" stroke="currentColor" fill="none"/></svg></span></span></span>'
    ];
}

// img slider
function doImgSlider (root) {
  if (root == null) { root = doc; }
  let imgSliderEls = root.querySelectorAll('.img-slider:not(.initialized)');
  if (imgSliderEls.length) {
    forEach(imgSliderEls, (el, i) => {
      sliderInit(el);
      let fakeCaption,
          imgBox = lookupByClass(el, 'img-box'),
          ctsC = imgBox ? imgBox.querySelector('.controls') : false,
          navC = imgBox ? imgBox.querySelector('.nav') : false,
          slider = tns({
            mode: 'gallery',
            container: el,
            controls: body.classList.contains('article-page'),
            controlsContainer: ctsC ? ctsC : false,
            controlsText: getControlsText('Image'),
            navContainer: navC ? navC : false,
            swipeAngle: 45,
            loop: false,
            autoHeight: true,
            onInit: function (info) {
              let wrapper = lookupByClass(el, 'img-slider-wrapper');

              if (wrapper) {
                let figcaption = info.slideItems[info.index].querySelector('figcaption');

                if (figcaption) {
                  wrapper.insertAdjacentHTML('afterend', '<div class="caption" aria-hidden="true"><div class="caption-content">' + figcaption.innerHTML + '</div></div>');
                  fakeCaption = wrapper.nextElementSibling;
                }
              }
            }
          });

      if (fakeCaption) {
        slider.events.on('indexChanged', function(info) {
          fakeCaption.innerHTML = info.slideItems[info.index].querySelector('figcaption').innerHTML;
        });
      }
    });
  }

  let expand_btns = doc.querySelectorAll('.btn-img-expand');
  expand_btns.length && forEach(expand_btns, (el) => {
    el.addEventListener('click', (e) => {
      let target = lookupByClass(e.target, 'img-box');
      if (target.classList.contains('left') || target.classList.contains('right')) {
        target.classList.toggle('expanded');
      }
    });
  });
};
doImgSlider();





// top bar news slider
let newsSliderEl = doc.querySelector('.topbar-news');
if (newsSliderEl) {
  sliderInit(newsSliderEl);
  let newsSlider = tns({
    container: newsSliderEl,
    loop: false,
    autoHeight: true,
    nav: false,
    slideBy: 'page',
    gutter: 20,
    controlsText: getControlsText('Page'),
    swipeAngle: 45,
    preventScrollOnTouch: 'auto',
    responsive: {
      600: { items: 2 },
      850: { items: 3 },
      1000: { items: 4 },
      1210: { items: 5 },
    },
  });
}
function doRelatedSlider (root) {
  if (root == null) { root = doc; }
  let relatedSliderEl = root.querySelector('.related-story-list:not(.initialized)');
  if (relatedSliderEl) {
    sliderInit(relatedSliderEl);
    let relatedStorySlider = tns({
      container: relatedSliderEl,
      loop: false,
      autoHeight: true,
      nav: false,
      slideBy: 'page',
      gutter: 20,
      controlsText: getControlsText('Page'),
      swipeAngle: 45,
      preventScrollOnTouch: 'auto',
      responsive: {
        600: { items: 2 },
        800: { items: 3 },
        1024: { items: 2 },
        // 1210: { items: 5 },
      },
    });
  }
}
doRelatedSlider();





// video slider
// let videoSliderEls = doc.querySelectorAll('.gallery-slider');
// for(let l = videoSliderEls.length; l--;) {
//   let el = videoSliderEls[l];

//   sliderInit(el);
//   let slider = tns({
//     container: el,
//     items: 2,
//     loop: false,
//     autoHeight: true,
//     gutter: 30,
//     slideBy: 'page',
//     controlsText: getControlsText('Page'),
//     swipeAngle: 45,
//     preventScrollOnTouch: 'auto',
//     nav: false,
//     disable: true,
//     responsive: {
//       // 500: { items: 2 },
//       640: { items: 3, nav: true, disable: false },
//       1000: { items: 4 },
//     },
//   })
// }


// video slider
// let slider4s = doc.querySelectorAll('.slider-4');
// forEach(slider4s, (el) => {
//   sliderInit(el);
//   let controls = el.parentNode.querySelector('.controls');
//   let slider = tns({
//     container: el,
//     loop: false,
//     autoHeight: true,
//     gutter: 30,
//     slideBy: 'page',
//     controlsContainer: controls,
//     swipeAngle: 45,
//     preventScrollOnTouch: 'auto',
//     nav: false,
//     responsive: {
//       500: { items: 2 },
//       640: { items: 3 },
//       1000: { items: 4 },
//     },
//   })
// });



// podcast list slider
// let podcastListSliderEl = doc.querySelector('.podcast-list-slider');
// if (podcastListSliderEl) {
//   sliderInit(podcastListSliderEl);
//   let newsSlider = tns({
//     container: podcastListSliderEl,
//     items: 2,
//     loop: false,
//     autoHeight: true,
//     nav: false,
//     slideBy: 'page',
//     gutter: 15,
//     controlsText: ['<span class="left-arrow"></span>', '<span class="right-arrow"></span>'],
//     swipeAngle: 45,
//     preventScrollOnTouch: 'auto',
//     responsive: {
//       540: { items: 3 },
//       768: { items: 4 },
//       940: { items: 5 },
//       1200: { items: 6 },
//     },
//   });
// }



let slider1Els = doc.querySelectorAll('.slider1');
if (slider1Els.length) {
  forEach(slider1Els, (el) => {
    sliderInit(el);
    var slider = tns({
      container: el,
      controlsContainer: el.parentNode.querySelector('.controls'),
      nav: false,
      gutter: 15,
      // loop: false,
      autoHeight: true,
      swipeAngle: 45,
      preventScrollOnTouch: 'auto',
      responsive: {
        960: {
          edgePadding: 200,
        }
      }
    });
  });
}
let slider4Els = doc.querySelectorAll('.slider4');
if (slider4Els.length) {
  forEach(slider4Els, (el) => {
    sliderInit(el);
    var slider = tns({
      container: el,
      controlsContainer: el.parentNode.querySelector('.controls'),
      loop: false,
      gutter: 26,
      slideBy: 'page',
      nav: false,
      autoHeight: true,
      swipeAngle: 45,
      preventScrollOnTouch: 'auto',
      responsive: {
        640: { items: 2 },
        980: { items: 3 },
        1260: { items: 4 }
      }
    });
  });
}


// tabs
// let tabpanels = doc.querySelectorAll('.panel-tabs'),
//     tabLen = tabpanels.length;
// if (tabLen) {
//   for(let l = tabLen; l--;) {
//     tabInit(tabpanels[l]);
//   }
// }

// function tabInit (el) {
//   let loadClass = 'loaded',
//       activeClass = 'is-active',
//       hideClass = 'visually-hidden',
//       tabs = el.querySelectorAll('.tabs button'),
//       tabsLen = tabs.length,
//       panels = el.querySelectorAll('.panel'),
//       panelsLen = panels.length;

//   if (tabsLen && panelsLen && tabsLen === panelsLen) {

//     for(let l = tabsLen; l--;) {
//       let item = tabs[l];
//       item.addEventListener('click', function() {
//         let order = Number(item.getAttribute('data-order'));

//         for(let o = tabsLen; o--;) {
//           if (o === order) {
//             // tabs[o].setAttribute('aria-expanded', 'true');
//             tabs[o].classList.add(activeClass);
//             panels[o].classList.remove(hideClass);
//           } else {
//             // tabs[o].setAttribute('aria-expanded', 'false');
//             tabs[o].classList.remove(activeClass);
//             panels[o].classList.add(hideClass);
//           }
//         }
//       });
//     }

//     tabs[0].click();
//     el.classList.add(loadClass);
//   }
// }



// article responsive embeded content
function makeEmbedFluid(root) {
  if (root == null) { root = doc; }
  let embeds = root.querySelectorAll('.embedded-content'),
      // player = /www.youtube.com|player.vimeo.com|www.facebook.com\/plugins\/video.php|www.google.com\/maps\/embed/,
      wrapClass = 'fluid-wrapper',
      itemClass = 'fluid-item';

  if (embeds.length) {
    forEach(embeds, (embed) => {
      let item = embed.querySelector('iframe');

      if (item && !item.classList.contains(itemClass)) { //  && item.src.search(player) > 0
        let width = item.width,
            height = item.height;

        if (height && width) {
          let ratio = (height / width) * 100,
              wrap = doc.createElement('div');
          wrap.className = wrapClass;

          embed.style.maxWidth = width + 'px';
          wrap.style.paddingTop = ratio + '%';
          item.classList.add(itemClass);

          embed.insertBefore(wrap, item);
          wrap.appendChild(item);
        }
      }
    });
  }
}
makeEmbedFluid();


// create account
// subscription toggle
// let subscription_toggle = doc.querySelector('.js-subscription-toggle');
// if (subscription_toggle) {
//   let subscription_field = lookupByClass(subscription_toggle, 'subscription-field');
//   if (subscription_field) {
//     let required_fields = subscription_field.querySelectorAll('[required]');

//     subscription_toggle.addEventListener('change', function() {
//       updateSubscriptionFields(subscription_toggle, subscription_field, required_fields);
//     });

//     win.addEventListener('load', function () {
//       updateSubscriptionFields(subscription_toggle, subscription_field, required_fields);
//     });
//   }
// }
// function updateSubscriptionFields (cb, box, inputs) {
//   let cl = 'hide-fields',
//       req_str = 'required';

//   if(cb.checked) {
//     box.classList.remove(cl);
//     if (inputs.length) {
//       forEach(inputs, function(item) {
//         item.setAttribute(req_str, '');
//       });
//     }
//   } else {
//     box.classList.add(cl);
//     if (inputs.length) {
//       forEach(inputs, function(item) {
//         item.removeAttribute(req_str);
//       });
//     }
//   }
// }

// search form validation
// let search_forms = doc.querySelectorAll('.search-form'),
//     search_forms_len = search_forms.length,
//     form_hide_class = 'visually-hidden',
//     input_error_class = 'error',
//     message_success_class = 'message-success',
//     message_error_class = 'message-error';

// if (search_forms_len) {
//   for(let i = search_forms_len; i--;) {
//     let search_form = search_forms[i],
//         input = search_form.querySelector('input'),
//         alert_field = search_form.querySelector('[role="alert"]');

//     search_form.onsubmit = function(e) { validateSearch(e, input, alert_field); }
//   }
// }

// // newsletter subscription validation
// let newsletter_forms = doc.querySelectorAll('.js-form'),
//     newsletter_forms_len = newsletter_forms.length;

// if (newsletter_forms_len) {
//   for(let i = newsletter_forms_len; i--;) {
//     let newsletter_form = newsletter_forms[i],
//         inputs = newsletter_form.querySelectorAll('[required]'),
//         alert_field = newsletter_form.querySelector('[role="alert"]');

//     newsletter_form.onsubmit = function(e) { validateNewsletter(e, inputs, alert_field); }
//   }
// }

// function validateSearch (e, input, al) {
//   // remove invalid charactors, extra white spaces
//   let value = input.value.replace(/\W/g, ' ').replace(/^\s+/, '').replace(/\s+$/, '').replace(/\s+/g, ' ');

//   if (!/^\s*$/.test(value)) {
//     input.value = value;
//     if(!al.classList.contains(form_hide_class)) {
//       al.innerHTML = '';
//       al.className = form_hide_class;
//     }
//     input.onfocus = input.onblur = input.onkeydown = null;
//   } else {
//     e.preventDefault();
//     if (al.classList.contains(form_hide_class)) {
//       al.innerHTML = '请输入关键字';
//       al.classList.remove(form_hide_class);
//       al.classList.add(message_error_class);
//     }
//     input.onfocus = input.onblur = input.onkeydown = function(e) { hideAlert(input); };
//   }
// }

// function validateNewsletter (e, inputs, al) {
//   let message_errors = [],
//       error_els = [],
//       pw_fields = [];

//   for(let l = 0; l < inputs.length; l++) {
//     let input = inputs[l],
//         value = input.value,
//         message_empty = '<li><a href="#' + input.id + '">' + input.name + ' field</a> is empty.</li>',
//         message_email = '<li><a href="#' + input.id + '">' + input.name + ' field</a> is wrong; please check the format.</li>',
//         message_password = '<li><a href="#' + input.id + '">passwords</a> do not match.</li>';
//         // message_success = 'Your message was sent successfully.';

//     if (input.getAttribute('type') === 'password') { pw_fields.push(input); }

//     if (/^\s*$/.test(value)) {
//       // check 'required' attribute once again in case it changed
//       if (input.hasAttribute('required')) {
//         message_errors.push(message_empty);
//         error_els.push(input);
//       }
//     } else {
//       if (input.getAttribute('type') === 'email' && !/([\w\.\-_]+)?\w+@[\w-_]+(\.\w+){1,}/.test(value)) {
//         message_errors.push(message_email);
//         error_els.push(input);
//       } else if (pw_fields.length === 2 && pw_fields[0].value !== pw_fields[1].value) {
//         message_errors.push(message_password);
//         pw_fields.forEach(function(el) {
//           error_els.push(el);
//         });
//       } else {
//         input.classList.remove(input_error_class);

//         let index = error_els.indexOf(input);
//         if (index >= 0) {
//           input.onfocus = input.onblur = input.onkeydown = null;
//           error_els.splice(index, 1);
//         }
//       }
//     }
//   }

//   if (error_els.length) {
//     for(let a = error_els.length; a--;) {
//       let inp = error_els[a];
//       inp.classList.add(input_error_class);
//       inp.onfocus = inp.onblur = inp.onkeydown = function(e) { hideAlert(inp); };
//     }
//   }

//   if (message_errors.length) {
//     if (al.classList.contains(form_hide_class)) {
//       al.innerHTML = '<ul>' + message_errors.join('') + '</ul>';
//       al.className = message_error_class;
//     }
//     e.preventDefault()

//   } else {
//     if(!al.classList.contains(form_hide_class)) {
//       al.className = form_hide_class;
//     }
//   }
// }

// function hideAlert (input) {
//   let alert_field = input.form.querySelector('[role="alert"]');
//   if (!alert_field.classList.contains(form_hide_class)) {
//     alert_field.innerHTML = '';
//     alert_field.classList.add(form_hide_class);
//   }

//   if (input.classList.contains(input_error_class)) {
//     input.classList.remove(input_error_class);
//   }
// }

// create account
// let subscription_field = doc.querySelector('.create-account-form .subscription-field');
// if (subscription_field) {
//   let subscription_radio_yes = subscription_field.querySelector('#yes'),
//       subscription_radios = subscription_field.querySelectorAll('input'),
//       subscription_box = subscription_field.querySelector('.adfree-plan-box');

//   if (subscription_radios.length && subscription_radio_yes && subscription_box) {
//     forEach(subscription_radios, function(radio) {
//       radio.addEventListener('change', function(e) {
//         subscription_box.style.display = subscription_radio_yes.checked ? '' : 'none';
//       });
//     });
//   }
// }

// login popup
// function doPopup () {
//   let popup_link_attr = 'data-popup-class',
//       popup_links = doc.querySelectorAll('[' + popup_link_attr + ']');
//   if (popup_links.length) {
//     forEach(popup_links, function(link) {
//       link.addEventListener('click', function(e) {
//         e.preventDefault();
//         let container_doc = top.document,
//             src = link.getAttribute('href'),
//             iframe = container_doc.querySelector('[src$="' + src + '"]');
//         if (iframe) {
//           iframe.style.display = '';
//         } else {
//           iframe = container_doc.createElement('iframe');
//           iframe.className = link.getAttribute(popup_link_attr);
//           iframe.src = src;
//           container_doc.body.appendChild(iframe);
//         }

//         // if ('ontouchstart' in window || 'onmsgesturechange' in window) {
//         //   body.classList.add('no-scroll');
//         // }
//       });
//     });
//   }
// }
// doPopup();

// edit profile
// let profile_forms = doc.querySelectorAll('.edit-form'),
//     profile_forms_len = profile_forms.length;
// if (profile_forms_len) {
//   forEach(profile_forms, function(profile_form, i) {
//     let edit_btn = profile_form.querySelector('.profile-edit'),
//         save_btn = profile_form.querySelector('.profile-save'),
//         cancel_btn = profile_form.querySelector('.profile-cancel');

//     edit_btn.addEventListener('click', function(e) {
//       e.preventDefault();
//       profile_form.classList.remove('view-mode');
//       profile_form.classList.add('edit-mode');

//       let input = profile_form.querySelector('input');
//       input.focus();
//       input.select();
//     });
//     cancel_btn.addEventListener('click', function(e) {
//       profile_form.classList.remove('edit-mode');
//       profile_form.classList.add('view-mode');

//       // remove alert info if it exists
//       let al = profile_form.querySelector('[role="alert"]');
//       if (al && al.className !== closeClass) {
//         al.innerHTML = '';
//         al.className = closeClass;
//       }

//       if (cancel_btn.classList.contains('profile-cancel-subscription')) {
//         let actives = profile_form.querySelectorAll('[checked]');
//         if (actives.length) {
//           forEach(actives, function(active) {
//             active.checked = false;
//             active.removeAttribute('checked');
//           });
//         }
//       }
//       e.preventDefault();
//     });
//   });
// }

// function inputFile (selector) {
//   var inputs = doc.querySelectorAll(selector);
//   if (inputs.length) {
//     Array.prototype.forEach.call(inputs, function(input) {
//       var label  = input.nextElementSibling,
//           labelVal = label.innerHTML;

//       input.addEventListener('change', function(e) {
//         var fileName = '';
//         if(this.files && this.files.length > 1) {
//           fileName = (this.getAttribute('data-multiple-caption') || '' ).replace('{count}', this.files.length);
//         } else {
//           fileName = e.target.value.split('\\').pop();
//         }

//         if(fileName) {
//           let info = label.querySelector('.info');
//           info.innerHTML = fileName;
//           info.classList.add('active');
//         } else {
//           label.innerHTML = labelVal;
//         }
//       });
//     });
//   }
// }
// inputFile('#sample-file');

// win.header_fns = function(obj) {
//   addToggleEvents(obj);
//   // doPopup();
// };
// win.page_fns = function(article) {
//   getElements(article);
//   // make embed content fluid
//   makeEmbedFluid(article);
//   // make sliders
//   doImgSlider(article);
//   doRelatedSlider(article);
//   addRelatedToggle(article);
//   // comments
//   // doCommentActions();
//   // doCmentActions();
//   // print
//   doPrint();
//   // add events
//   addToggleEvents(article);
//   scroll_to(article);

//   // get positions
//   getStoriesTop();
// };

// print
function beforeprint () {
  if (body.classList.contains('article-page') ||
      body.classList.contains('static-page') ||
      body.classList.contains('search-results-page')) {

    let mainClass = doc.querySelector('.full-article') ? '.full-article' : 'main',
        printStr = 'printlinks',
        printlinks = doc.querySelector(mainClass+' .'+printStr),
        baseurl = 'https://www.christianpost.com';
    if (!printlinks) {
      let printlinks = doc.createElement('ul'),
          printlinksStr = '',
          article = doc.querySelector(mainClass);
      if (article) {
        printlinks.className = printStr;
        let links = doc.querySelectorAll(mainClass+' a:not([href^="mailto:"])'),
            linkorder = 1;

        for (var i = 0; i < links.length; i++) {
          let link = links[i],
              href = link.getAttribute('href');

          // if (href !== link.textContent && href !== baseurl && href !== baseurl+'/') {
          if (href !== link.textContent && !lookupByClass(link, 'pagination')) {
            if (href.indexOf('http') < 0) {
              let connectStr = href.charAt(0) === '/' ? '':'/';
              href = baseurl + connectStr + href;
            }

            printlinksStr += '<li>'+linkorder+'. '+href+'</li>';
            link.insertAdjacentHTML('afterend', '<sup class="link-order"> ('+linkorder+')</sup>');

            linkorder++;
          }
        }

        printlinks.innerHTML = printlinksStr;
        article.appendChild(printlinks);
      }
    }
  }
}

win.onbeforeprint = beforeprint;